import ValidationMessages from '../../../components/common/Validation/validationMessageConfig'
import { BACKEND_UNAVAILABLE_MESSAGE } from '../../../utils/apiError'

export interface ValidationBannerMapResult {
  variant?: 'info' | 'error'
  heading?: JSX.Element
  showMessage?: boolean
  messageNode?: JSX.Element
}

/**
 * Maps shared request-validation messages to ValidationBanner content.
 */
export const mapCommonValidationMessage = (
  text: string,
  onFocusOtherSubtype: () => void
): ValidationBannerMapResult | null => {
  const {
    DURATION,
    BALANCE,
    FLEXIBLE_BALANCE,
    FLOAT_BALANCE,
    FLEXIBLE_DURATION,
    FLEXIBLE_MIN_TWO_HOURS,
    FLOAT_DURATION,
    OTHER_SUBTYPE_REQUIRED,
    NO_HOURS_ENTERED,
    NO_HOURS_ENTERED_PARTIAL_DAY,
    PARTIAL_DAY_TIME_ORDER,
    PARTIAL_DAY_HOURS_EXCEED_DURATION,
    PARTIAL_DAY_HOURS_LESS_THAN_DURATION,
    REQUEST_DATES_EXCEED_8_DAY_GAP,
    REVISE_REQUEST,
  } = ValidationMessages

  if (text === DURATION) {
    return {
      heading: <p className="p1 -medium m-0!">{DURATION}</p>,
      showMessage: true,
      messageNode: <p className="p3 -book m-0!">{REVISE_REQUEST}</p>,
    }
  }

  if (text === FLOAT_DURATION) {
    return {
      heading: <p className="p1 -medium m-0!">{FLOAT_DURATION}</p>,
      showMessage: true,
      messageNode: <p className="p3 -book m-0!">{REVISE_REQUEST}</p>,
    }
  }

  if (text === BALANCE) {
    return {
      variant: 'info',
      heading: (
        <p className="p1 -medium m-0!">
          Total request exceeds your available balance.
        </p>
      ),
      showMessage: true,
      messageNode: <p className="p3 -book m-0!">{BALANCE}</p>,
    }
  }

  if (text === FLEXIBLE_BALANCE) {
    return {
      heading: <p className="p1 -medium m-0!">{FLEXIBLE_BALANCE}</p>,
      showMessage: false,
    }
  }

  if (text === FLOAT_BALANCE) {
    return {
      heading: <p className="p1 -medium m-0!">{FLOAT_BALANCE}</p>,
      showMessage: false,
    }
  }

  if (text === OTHER_SUBTYPE_REQUIRED) {
    return {
      heading: <p className="p1 -medium m-0!">{OTHER_SUBTYPE_REQUIRED}</p>,
      showMessage: true,
      messageNode: (
        <p className="p3 -book m-0!">
          Choose an{' '}
          <button
            type="button"
            onClick={onFocusOtherSubtype}
            className="p3 -book text-[#0074AD]! underline cursor-pointer border-0 bg-transparent p-0 hover:opacity-80"
          >
            Other Type of Time Off
          </button>{' '}
          from the list to continue.
        </p>
      ),
    }
  }

  if (text === NO_HOURS_ENTERED) {
    return {
      heading: <p className="p1 -medium m-0!">Please enter Hours per day.</p>,
      showMessage: true,
      messageNode: <p className="p3 -book m-0!">{NO_HOURS_ENTERED}</p>,
    }
  }

  if (text === NO_HOURS_ENTERED_PARTIAL_DAY) {
    return {
      heading: <p className="p1 -medium m-0!">Please enter Hours per day.</p>,
      showMessage: true,
      messageNode: (
        <p className="p3 -book m-0!">{NO_HOURS_ENTERED_PARTIAL_DAY}</p>
      ),
    }
  }

  if (text === FLEXIBLE_DURATION) {
    return {
      heading: <p className="p1 -medium m-0!">{FLEXIBLE_DURATION}</p>,
      showMessage: false,
    }
  }

  if (text === FLEXIBLE_MIN_TWO_HOURS) {
    return {
      heading: <p className="p1 -medium m-0!">{FLEXIBLE_MIN_TWO_HOURS}</p>,
      showMessage: true,
      messageNode: <p className="p3 -book m-0!">{REVISE_REQUEST}</p>,
    }
  }

  if (text === PARTIAL_DAY_TIME_ORDER) {
    return {
      heading: <p className="p1 -medium m-0!">{PARTIAL_DAY_TIME_ORDER}</p>,
      showMessage: false,
    }
  }

  if (text === PARTIAL_DAY_HOURS_EXCEED_DURATION) {
    return {
      heading: (
        <p className="p1 -medium m-0!">{PARTIAL_DAY_HOURS_EXCEED_DURATION}</p>
      ),
      showMessage: true,
      messageNode: <p className="p3 -book m-0!">{REVISE_REQUEST}</p>,
    }
  }
    if (text === PARTIAL_DAY_HOURS_LESS_THAN_DURATION) {
    return {
      heading: (
        <p className="p1 -medium m-0!">{PARTIAL_DAY_HOURS_LESS_THAN_DURATION}</p>
      ),
      showMessage: true,
      messageNode: <p className="p3 -book m-0!">{REVISE_REQUEST}</p>,
    }
  }

  if (text === BACKEND_UNAVAILABLE_MESSAGE) {
    return {
      heading: (
        <p className="p1 -medium m-0!">Could not process the time off request</p>
      ),
      showMessage: true,
      messageNode: (
        <p className="p3 -book m-0!">
          If the problem continues after re-logging in, email the National
          TORT Support team at{' '}
          <a
            href="mailto:NAT-TORT@kp.org"
            className="text-[#0074AD] hover:text-[#0074AD]! transition-none!"
          >
            NAT-TORT@kp.org
          </a>{' '}
          with your name, employee ID, NUID, computer screenshots, and a
          description of the issue.
        </p>
      ),
    }
  }

  if (text === REQUEST_DATES_EXCEED_8_DAY_GAP) {
    return {
      heading: <p className="p1 -medium m-0!">{REQUEST_DATES_EXCEED_8_DAY_GAP}</p>,
      showMessage: true,
      messageNode: (
        <p className="p3 -book m-0!">
          If these dates represent more than one time off request, please submit
          them as separate requests.
        </p>
      ),
    }
  }

  return null
}
